module.exports = __webpack_public_path__ + "img/Component 3.98792bc7.svg";